import { Progress, ProgressProps } from '@chakra-ui/react';

export const InfiniteProgressBar: React.FC<ProgressProps> = ({
  color = 'linear-gradient(to right, transparent 0%, #1565bc 10%, #1565bc 90%, transparent 100%)',
  bgColor = 'neutral.EBEFF3',
  ...props
}) => (
  <Progress
    h="20px"
    borderRadius="4px"
    bgColor={bgColor}
    isIndeterminate
    sx={{
      '& div[role=progressbar]': {
        bgColor: color,
      },
    }}
    {...props}
  />
);
